import { Component, effect, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { combineLatestWith, Observable, Subject } from 'rxjs';

import { UserStateService } from '@bn/auth/stores';
import { AbstractLazyDirective } from '@bn/features/abstracts/abstract-lazy.directive';
import { ClickActionEvent } from '@bn/primitives';

@Component({
  templateUrl: './extend-trial-all-users.component.html',
  styleUrls: ['./extend-trial-all-users.component.scss'],
  standalone: false,
})
export class ExtendTrialAllUsersModalComponent extends AbstractLazyDirective {
  readonly #dialog = inject<BsModalRef<ExtendTrialAllUsersModalComponent>>(BsModalRef);

  readonly #accountStore = inject(UserStateService).accountStore;
  readonly #userStore = inject(UserStateService).userStore;

  public isLoading = false;
  public isSuccess = false;
  public isError = false;
  public totalBandwidth = 0;
  public usedBandwidth = 0;

  public trialBalance = 0;
  public usedTrialBalance = 0;
  public totalTrialBalance = 0;

  private readonly onAction = new Subject<ClickActionEvent>();

  constructor() {
    super();

    toObservable(this.#accountStore.billingTrialOverview)
      .pipe(takeUntilDestroyed(), combineLatestWith(this.route.fragment))
      .subscribe(([billingTrialOverview]) => {
        if (!billingTrialOverview) return;

        this.trialBalance = billingTrialOverview.TrialBalance;
        this.usedTrialBalance = billingTrialOverview.TrialUsage;
        this.totalTrialBalance = this.trialBalance + this.usedTrialBalance;
      });

    effect(() => {
      const user = this.#userStore.userDetails();

      if (user) {
        this.totalBandwidth = user.TrialBandwidthLimit ?? 0;
        this.usedBandwidth = user.TotalBandwidthUsed ?? 0;
      }
    });
  }

  public onExtendTrialClick(): void {
    this.isLoading = true;

    this.userDetailsService.extendFreeTrialAllUsers().subscribe({
      next: () => {
        this.isSuccess = true;
        this.isLoading = false;

        this.onAction.next({
          action: 'confirm',
        });
      },
      error: () => {
        this.isError = true;
        this.isLoading = false;
      },
    });
  }

  public getOnAction$(): Observable<ClickActionEvent> {
    return this.onAction.asObservable();
  }

  public onClose(): void {
    this.#dialog.hide();
  }
}
